import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

export default function NavButtons({ 
  onNext, 
  onBack, 
  nextLabel = "Continue", 
  disabled = false, 
  showBack = true, 
  icon = "ArrowRight" 
}) {
  const [isShaking, setIsShaking] = useState(false);

  const handleDisabledClick = () => {
    if (disabled) {
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 400);
    }
  };

  return (
    <div className={`flex flex-col-reverse sm:flex-row items-center gap-4 pt-10 w-full ${showBack ? 'sm:justify-between' : 'sm:justify-end'}`}>
      {showBack ? (
        <button 
          onClick={onBack} 
          className="w-full sm:w-auto min-h-[52px] px-10 rounded-full bg-white border border-sage-200 text-sage-500 font-semibold text-lg flex items-center justify-center gap-2 transition-all hover:bg-sage-50/50 active:scale-95 shadow-sm"
        >
          <SafeIcon name="ArrowLeft" /> 
          Back
        </button>
      ) : (
        <div className="hidden sm:block" /> // Spacer for desktop layout when no back button
      )}

      <div className="relative w-full sm:w-auto" onClick={handleDisabledClick}>
        <motion.button
          disabled={disabled}
          onClick={onNext}
          animate={disabled ? {} : { scale: [1, 1.02, 1] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          className={`
            w-full sm:min-w-[280px] min-h-[52px] px-10 rounded-full font-semibold text-lg flex items-center justify-center gap-3 transition-all duration-300
            ${disabled 
              ? 'bg-sage-100 text-sage-400 cursor-not-allowed shadow-none' 
              : 'bg-blush-300 text-white shadow-soft hover:bg-blush-400 hover:shadow-glow active:scale-95'
            }
            ${isShaking ? 'animate-shake' : ''}
          `}
        >
          {nextLabel}
          <SafeIcon name={icon} className={disabled ? "text-sage-300" : "text-white"} />
        </motion.button>
      </div>
    </div>
  );
}
